export const SMALL_MEDIUM_BREAKPOINT = "900px"
export const MEDIUM_LARGE_BREAKPOINT = "1200px"
export const MEDIUM_SIDEBAR_WIDTH = "245px"
export const LARGE_SIDEBAR_WIDTH = "324px"
